export const getGroupCommission = ({ positionList = [], symbolParam, symbol, refSymbol, side }) => {
    if (!symbol || !symbol.bid || !symbol.ask || !symbolParam) return 0;

    const price = side === 1 ? symbol.bid : symbol.ask;

    const getRefValue = () => {
        const { referenceSymbolCalculationType } = symbolParam;
        if (!symbol.referenceSymbolId || !refSymbol) return 1;
        return referenceSymbolCalculationType === "Division" ? 1 / price : price;
    };

    const totalCommission = positionList.reduce((total, pos) => {
        const { closeCommissionValue, closeCommissionType } = symbolParam;
        let commission = 0;

        switch (closeCommissionType) {
            case 1:
                commission = pos.amount * symbol.contractSize * price * 0.01 * closeCommissionValue * getRefValue();
                break;
            case 2:
                commission = closeCommissionValue * pos.amount;
                break;
            case 3:
                commission = closeCommissionValue;
                break;
            default:
                commission = 0;
        }

        return total + commission;
    }, 0);

    return totalCommission;
};
export const getGroupNetOpenValue = (positionList = [], contractSize = 100) => {
    let numerator = 0;
    let denominator = 0;

    for (const pos of positionList) {
        const amount = pos.side === 1 ? pos.amount : -pos.amount;
        const openPrice = pos.openPrice ?? 0;
        numerator += amount * openPrice;
        denominator += amount;
    }

    const avgOpenPrice = denominator ? numerator / denominator : 0;
    const value = denominator * avgOpenPrice * contractSize;

    return isFinite(value) ? value : 0;
};
export const getGroupInterest = (positionList = []) => {
    return positionList.reduce((total, pos) => total + (pos.interest ?? 0), 0);
};
export const getGroupNetValue = (positionList = [], symbol, side) => {
    if (!symbol || (!symbol.bid && !symbol.ask)) return 0;

    const price = (symbol.bid + symbol.ask) / 2; 
    const contractSize = symbol.contractSize ?? 100;

    let totalAmount = 0;
    for (const pos of positionList) {
        totalAmount += pos.side === 1 ? (pos.amount ?? 0) : -(pos.amount ?? 0);
    }

    const value = totalAmount * price * contractSize;
    return isFinite(value) ? value : 0;
};
export function calculateGroupPL({ positionList, symbolId, side, symbols, allSymbolParams }) {
    const symbol = symbols?.[symbolId];
    const refSymbol = symbols?.[symbol?.referenceSymbolId] || null;
    const symbolData = allSymbolParams?.[symbolId];
    if (!symbol || !symbolData || !symbol.bid || !symbol.ask) return 0;

    const currentPrice = side === 1 ? symbol.bid : symbol.ask;

    const calculateRefValue = () => {
        if (!symbolData) return 1;
        const { referenceSymbolCalculationType } = symbolData;
        if (!symbol.referenceSymbolId || !refSymbol) return 1;
        return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
    };

    const refValue = calculateRefValue();

    let total = 0;

    for (const row of positionList) {
        const { amount, openPrice, interest = 0 } = row;
        const { closeCommissionValue, closeCommissionType } = symbolData;

        let commission = 0;
        if (closeCommissionType === 1) {
            commission = amount * symbol.contractSize * currentPrice * 0.01 * closeCommissionValue * refValue;
        } else if (closeCommissionType === 2) {
            commission = closeCommissionValue * amount;
        } else if (closeCommissionType === 3) {
            commission = closeCommissionValue;
        }

        let profitLoss = 0;

        if (!symbol.referenceSymbolId || !refSymbol?.bid) {
            profitLoss = side === 1
                ? (currentPrice - openPrice) * symbol.contractSize * amount
                : (openPrice - currentPrice) * symbol.contractSize * amount;
        } else {
            if (symbol.referenceSymbolCalculationType === 1) {
                profitLoss = side === 1
                    ? ((currentPrice - openPrice) * refSymbol.bid) * symbol.contractSize * amount
                    : ((openPrice - currentPrice) * refSymbol.bid) * symbol.contractSize * amount;
            } else {
                profitLoss = side === 1
                    ? ((currentPrice - openPrice) / refSymbol.bid) * symbol.contractSize * amount
                    : ((openPrice - currentPrice) / refSymbol.bid) * symbol.contractSize * amount;
            }
        }

        profitLoss = profitLoss - commission + interest;

        if (!isFinite(profitLoss)) profitLoss = 0;

        total += profitLoss;
    }

    return Math.abs(total) < 0.005 ? 0 : total.toFixed(2);
}
